// extracted by mini-css-extract-plugin
export default {"editButton":"hrRelease_editButton__uCf5s","TableBody":"hrRelease_TableBody__giBGC","StopButton":"hrRelease_StopButton__S2mPu"};